import React from "react";

export default function Multiline(props) {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        handeOnChange,
        getEvaluatedValue,
        encryptionDecryptions,
        handleEncryptionDecryption
    } = props;

    const value = comp?.rule
        ? getEvaluatedValue(comp.rule)
        : data[controleId] || "";

    const getFieldIcon = () => {
        const labelLower = (comp.label || "").toLowerCase();
        if (labelLower.includes("comment") || labelLower.includes("note") || labelLower.includes("remark") || labelLower.includes("description")) return "fa-commenting-o";
        if (labelLower.includes("address")) return "fa-map-marker";
        return "fa-file-text-o";
    };

    return (
        <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
            {comp.label && (
                <label className="form-control-label" htmlFor={controleId} style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.7px",
                    marginBottom: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                }}>
                    <i className={`fa ${getFieldIcon()}`} style={{ color: "#94a3b8", fontSize: "11px" }} />
                    {comp.label}
                </label>
            )}

            <div className="wf-input-wrap" style={{ position: "relative" }}>
                <i className={`fa ${getFieldIcon()} wf-input-icon`} aria-hidden="true" style={{ top: "14px" }} />
                <textarea
                    id={controleId}
                    name={controleId}
                    className="form-control"
                    rows={3}
                    value={value}
                    onChange={handeOnChange}
                    disabled={isDisabled}
                    data-encryption={comp.encryptionValidate}
                    placeholder={comp.label || ""}
                    style={{ paddingLeft: "36px", paddingRight: comp.encryptionValidate ? "36px" : "12px", paddingTop: "10px", minHeight: "80px", resize: "vertical" }}
                />

                {comp.encryptionValidate && (
                    <button
                        type="button"
                        onClick={() => handleEncryptionDecryption(controleId)}
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "12px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            color: "#64748b",
                            fontSize: "14px",
                            zIndex: 10
                        }}
                    >
                        <i className={`fa ${encryptionDecryptions && encryptionDecryptions[controleId] === "" ? "fa-eye-slash" : "fa-eye"}`} />
                    </button>
                )}
            </div>

            {errors[controleId] && (
                <div className="alert alert-danger" style={{ marginTop: 6, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px" }}>
                    {errors[controleId]}
                </div>
            )}
        </div>
    );
}
